import { render, staticRenderFns } from "./AnnotationBadge.vue?vue&type=template&id=f2bb5e88&scoped=true&lang=pug"
import script from "./AnnotationBadge.vue?vue&type=script&lang=js"
export * from "./AnnotationBadge.vue?vue&type=script&lang=js"
import style0 from "./AnnotationBadge.vue?vue&type=style&index=0&id=f2bb5e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bb5e88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
